/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-config.js to modify the generation of this file.
const config = {};
config.sitecoreApiKey = import.meta.env.VITE_SITECORE_API_KEY || "#APIKEY#";
config.sitecoreApiHost = import.meta.env.VITE_SITECORE_API_HOST || "#LAYOUTSERVICEHOST#";
config.sitecoreSiteName = import.meta.env.VITE_SITECORE_SITE_NAME || "rddk";
config.graphQLEndpointPath = import.meta.env.VITE_GRAPH_QL_ENDPOINT_PATH || "api/rddk";
config.defaultLanguage = import.meta.env.VITE_DEFAULT_LANGUAGE || "da";
config.defaultAppRoute = import.meta.env.VITE_DEFAULT_APP_ROUTE || "/da/privat";
config.graphQLEndpoint = import.meta.env.VITE_GRAPH_QL_ENDPOINT || "#LAYOUTSERVICEHOST#api/rddk";
config.layoutServiceConfigurationName = import.meta.env.VITE_LAYOUT_SERVICE_CONFIGURATION_NAME || "jss";
export default config;